import { QidProduct } from "server/models"
import {
    OrderType,
    inferLiteral,
    QidCalculationMethod,
} from "client/utils"
import {
    SilDeviceType,
    SilDeviceList,
    SilDeviceFilters,
    QidProductList,
    QidProductFilters,
    ResultDatapointListType,
} from "client/store"
import * as types from "./types"


export const setSilModelDevicesActiveTab = (tab: string) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACTIVE_TAB),
    tab,
})
export const setSilModelDevicesModelTarget = (modelTarget: types.ModelTargetType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_MODEL_TARGET),
    modelTarget,
})
export const setSilModelDevicesOnSelect = (action: types.SilModelDeviceOnSelect) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ON_SELECT),
    action,
})


export const setSilModelDevicesAccountDeviceList = (deviceList: SilDeviceList) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_DEVICE_LIST),
    deviceList,
})
export const setSilModelDevicesAccountDeviceIds = (deviceIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_DEVICE_IDS),
    deviceIds,
})
export const setSilModelDevicesAccountDeviceSort = (sortColumn: keyof SilDeviceType, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_DEVICE_SORT),
    sortColumn,
    sortOrder,
})
export const setSilModelDevicesAccountDeviceFilters = (filters: SilDeviceFilters) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_DEVICE_FILTERS),
    filters,
})


export const setSilModelDevicesAccountSubsystemList = (deviceList: SilDeviceList) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_LIST),
    deviceList,
})
export const setSilModelDevicesAccountSubsystemIds = (deviceIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_IDS),
    deviceIds,
})
export const setSilModelDevicesAccountSubsystemSort = (sortColumn: keyof SilDeviceType, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_SORT),
    sortColumn,
    sortOrder,
})
export const setSilModelDevicesAccountSubsystemFilters = (filters: SilDeviceFilters) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_FILTERS),
    filters,
})


export const setSilModelDevicesProjectDeviceList = (deviceList: SilDeviceList) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_DEVICE_LIST),
    deviceList,
})
export const setSilModelDevicesProjectDeviceIds = (deviceIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_DEVICE_IDS),
    deviceIds,
})
export const setSilModelDevicesProjectDeviceSort = (sortColumn: keyof SilDeviceType, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_DEVICE_SORT),
    sortColumn,
    sortOrder,
})
export const setSilModelDevicesProjectDeviceFilters = (filters: SilDeviceFilters) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_DEVICE_FILTERS),
    filters,
})


export const setSilModelDevicesProjectSubsystemList = (deviceList: SilDeviceList) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_LIST),
    deviceList,
})
export const setSilModelDevicesProjectSubsystemIds = (deviceIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_IDS),
    deviceIds,
})
export const setSilModelDevicesProjectSubsystemSort = (sortColumn: keyof SilDeviceType, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_SORT),
    sortColumn,
    sortOrder,
})
export const setSilModelDevicesProjectSubsystemFilters = (filters: SilDeviceFilters) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_FILTERS),
    filters,
})


export const setSilModelDevicesQidProductList = (productList: QidProductList) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_PRODUCT_LIST),
    productList,
})
export const setSilModelDevicesQidProductIds = (productIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_PRODUCT_IDS),
    productIds,
})
export const setSilModelDevicesQidProductSort = (sortColumn: keyof QidProduct, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_PRODUCT_SORT),
    sortColumn,
    sortOrder,
})
export const setSilModelDevicesQidProductFilters = (filters: QidProductFilters) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_PRODUCT_FILTERS),
    filters,
})


export const setSilModelDevicesQidExpanded = (expanded: types.SilModelDevicesQidExpanded) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_EXPANDED),
    expanded,
})
export const setSilModelDevicesQidClearExpanded = () => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_CLEAR_EXPANDED),
})


export const setSilModelDevicesQidDatapointList = (
    productId: number,
    datapoints: ResultDatapointListType,
) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_DATAPOINT_LIST),
    productId,
    datapoints,
})
export const setSilModelDevicesQidClearDatapointList = () => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_CLEAR_DATAPOINT_LIST),
})


export const setSilModelDevicesQidCalculationMethod = (calculationMethod: QidCalculationMethod) => ({
    type: inferLiteral(types.SIL_MODEL_DEVICES_QID_CALCULATION_METHOD),
    calculationMethod,
})
